import React, { useMemo, useState } from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { PatternFormat } from 'react-number-format';
import Table from 'components/common/Table';
import { hasIdentityVerification } from 'components/common/DeleteVerificationModal';

const TenantsTable = ({ tenants, onTenantClick, onDeleteVerification }) => {
    const hasActions = Boolean(onDeleteVerification);

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedTenant, setSelectedTenant] = useState(null);

    const handleMenuClick = (event, tenant) => {
        setAnchorEl(event.currentTarget);
        setSelectedTenant(tenant);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedTenant(null);
    };

    const handleDeleteVerification = () => {
        onDeleteVerification?.(selectedTenant);
        handleMenuClose();
    };

    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
                Cell: ({ row }) => `${row.original.first_name} ${row.original.last_name}`
            },
            {
                Header: 'Phone',
                accessor: 'phone',
                Cell: ({ row }) => (
                    <Typography
                        sx={{ fontSize: '13px' }}
                        component="span"
                        variant="body1"
                        color="text.primary"
                    >
                        <PatternFormat
                            value={row.original?.phone?.number || ''}
                            displayType={'text'}
                            format={`+${row.original?.phone?.code} (###)-###-####`}
                        />
                    </Typography>
                )
            },
            {
                Header: 'Status',
                accessor: 'status',
                className: 'cell-center',
                Cell: ({ value }) => (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '80%',
                            width: '30%',
                            backgroundColor:
                                value === 'Active'
                                    ? 'rgba(45, 143, 87, .1)'
                                    : 'rgba(255, 0, 0, .1)',
                            borderRadius: '5px'
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '13px',
                                marginX: '10px'
                            }}
                            component="span"
                            variant="body1"
                            color={
                                value === 'Active'
                                    ? 'rgba(45, 143, 87, 1)'
                                    : 'rgba(255, 0, 0, 1)'
                            }
                        >
                            {value}
                        </Typography>
                    </div>
                )
            },
            ...(hasActions
                ? [
                      {
                          Header: 'Actions',
                          className: 'cell-right',
                          Cell: ({ row }) => (
                              <IconButton
                                  onClick={e => {
                                      e.stopPropagation();
                                      handleMenuClick(e, row.original);
                                  }}
                              >
                                  <MoreHoriz />
                              </IconButton>
                          )
                      }
                  ]
                : [])
        ],
        [hasActions]
    );

    return (
        <>
            <Table columns={columns} data={tenants} onRowClick={onTenantClick} />
            {hasActions && (
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    {onDeleteVerification && (
                        <MenuItem
                            onClick={handleDeleteVerification}
                            disabled={!hasIdentityVerification(selectedTenant)}
                        >
                            Delete Verification
                        </MenuItem>
                    )}
                </Menu>
            )}
        </>
    );
};

export default TenantsTable;
